import React from 'react';
import propTypes from 'prop-types';
import classNames from 'classnames';

import TextInput from 'common/TextInput';

const ModalTextInput = ({
  baseString,
  defaultValue,
  labelText,
  onChange,
  validationResult
}) => {
  const classString = classNames({
    [`${baseString}`]: true,
    'vra-modal-text-input': true
  });

  return (
    <section className={classString}>
      <div className={`${baseString}__input-wrapper`}>
        <TextInput
          dataTestId='vra-rx-name__input'
          defaultValue={defaultValue}
          label={labelText}
          onChange={onChange}
          validationResult={validationResult}
        />
      </div>
    </section>
  );
};
ModalTextInput.propTypes = {
  baseString: propTypes.string.isRequired,
  defaultValue: propTypes.string,
  isRequired: propTypes.bool,
  labelText: propTypes.string.isRequired,
  onChange: propTypes.func.isRequired,
  validationResult: propTypes.object
};
export default ModalTextInput;
